export default __webpack_public_path__ + "static/media/1568.38fed67e.png";